export const visit = (vm, at) => {
at({ "en": { "invoiceSync": { "failureBanner": { "titleText": "Your QuickBooks Online integration has invoice sync failures", "linkText": "Sync failure details" } } } });
};